import { Icon } from '@iconify/react/dist/iconify.js';
import React from 'react';
import { Link } from 'react-router-dom';
import TablaDescargas from '../utils/TablaDescargas';

const DescargasLayer = () => {
    return (
        <>
        <TablaDescargas/>
        </>
    );
};

export default DescargasLayer;